<template>
  <div
    class="flex relative items-center py-1 pr-1.5 pl-2 mr-1 max-h-10 text-white bg-gradient-to-tr rounded from-[#977622] to-[#f0cb6d]"
  >
    <span class="text-xs font-semibold">ve8020</span>
  </div>
</template>
